import React from 'react';

import { theme } from 'antd';

const { useToken } = theme;

const OxidationReductionPotentialIcon = ({
  color,
  ...rest
}: {
  color?: string;
  className?: string;
  [x: string]: unknown;
}) => {
  const { token } = useToken();
  return (
    <svg width="50px" height="44px" viewBox="0 0 50 44" version="1.1" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <text
        id="ORP"
        fontFamily="Heebo-ExtraBold, Heebo"
        fontSize="16"
        fontWeight="700"
        fill={color ?? token.colorBorder}
      >
        <tspan x="9" y="28">
          ORP
        </tspan>
      </text>
    </svg>
  );
};

export default OxidationReductionPotentialIcon;
